// src/components/PrivacyPage.js
import React, { useContext } from 'react';
import { LanguageContext } from '../translations/LanguageContext';
import ReactMarkdown from 'react-markdown';
import './PrivacyPage.css'; // Import the corresponding CSS
import Footer from '../components/Footer'; // Importing the Footer component

function PrivacyPage() {
  const { language, translations } = useContext(LanguageContext);
  const privacy = translations[language].privacyPage;

  return (
  <div>
    <div className="privacy-page">
      <h1>{privacy.title}</h1>
      <div className="privacy-content">
        <ReactMarkdown>{privacy.content}</ReactMarkdown>
      </div>
    </div>
    <Footer/>
  </div>
  );
}

export default PrivacyPage;
